import { Component, Input, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { User } from 'src/app/classes/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
  selector: 'app-extend2-fa',
  templateUrl: './extend-2fa.component.html',
  styleUrl: './extend-2fa.component.css'
})
export class Extend2FAComponent implements OnInit{


  @Input() _user: User = new User();

	logoSrc: SafeUrl = "";


  constructor(
    private authenticationService: AuthenticationService,
	private customerService: CustomerService,
  ) {}


  ngOnInit() {

	this.logoSrc = this.customerService.getLoadedLogo();

    this._user = this.authenticationService.getCurrentUser(); 

    console.log('Benutzer geladen:', this._user);

  //     if (users.length > 0) {
  //       this._user = users[0]; 
  //       console.log('Benutzer geladen:', this._user);
  //     } else {
  //       console.log('Keine Benutzer gefunden');
  //     }

  //      // Wenn 2FA eingerichtet ist, Benutzer zur Login-Seite zurückleiten
  //   this.userService.twoFASetupComplete.subscribe(success => {
  //     console.log('success');
  //     if (success) {
  //         // this.router.navigate(['/login']);
  //     }
  // });
  //   });
  
    console.log("Initiere 2FA");

  }

}
